export default __webpack_public_path__ + "static/bg-abandoned-robot--mobile-0d5eae5ddcbc444e59a4490c7398c586.jpg";